import styled from 'styled-components';
import { space, color, query, font } from '@design/templateFns';

// HEADER
export const Header = styled.h2`
  ${font('headline-xxs')}
  margin-bottom: ${space('x6')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-sm')}
    margin-bottom: ${space('x7')};
  }
`;

// TABS
export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #d4d4d4;
  margin-bottom: ${space('x6')};
  overflow-x: scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  @media screen and (${query.atLeast('tablet')}) {
    overflow-x: hidden;
    margin-bottom: ${space('x8')};
  }
`;

export const Tab = styled.button<{ $active: boolean }>`
  border: none;
  text-decoration: none;
  background: none;
  margin-right: ${space('x6')};
  padding: ${space('sm')} 0;
  cursor: pointer;
  border-bottom: ${({ $active }) => ($active ? '3px solid #E60000' : '3px solid transparent')};
  color: ${({ $active }) => ($active ? '#242323' : '#757575')};
  white-space: nowrap;
  ${font('subhead-xs')}

  @media screen and (${query.atLeast('tablet')}) {
    margin-right: ${space('x8')};
    ${font('subhead-sm')}
  }
`;

export const ListingsContainer = styled.ul<{
  $notGrid?: boolean;
  $smallGap?: boolean;
}>`
  list-style: none;
  display: grid;
  grid-template-columns: ${({ $notGrid }) => ($notGrid ? '1fr' : '1fr 1fr')};
  grid-row-gap: ${({ $smallGap }) => ($smallGap ? '24px' : '36px')};
  grid-column-gap: 24px;

  @media screen and (${query.atLeast('tablet')}) {
    grid-template-columns: ${({ $notGrid }) => ($notGrid ? '1fr' : '1fr 1fr 1fr 1fr')};
  }
`;

export const ListingContainerNonGrid = styled.ul`
  display: block;
`;

//
//
// Property Listings
//
export const Listing = styled.li``;

export const ListingHeader = styled.h4`
  margin: 0;
  padding: 0;
  ${font('body-sm')}

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md')}
  }
`;

export const ContentSpan = styled.span`
  ${font('body-sm-light')};
  color: ${color('gray4')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
  }
`;

export const NoContentSpan = styled(ContentSpan)`
  visibility: hidden;
  opacity: 0;
`;

//
//
// Community Listings
//
export const ListingWithImage = styled(Listing)`
  display: grid;
  grid-template-columns: ${space('x7')} 1fr;
  align-content: start;
  column-gap: ${space('sm')};

  @media screen and (${query.atLeast('tablet')}) {
    column-gap: ${space('lg')};
  }
`;
export const ListingImageWrapper = styled.div`
  grid-row: span 2;
  order: 1;
  position: relative;

  img {
    width: 100%;
    height: auto;
  }

  @media screen and (${query.atLeast('tablet')}) {
  }
`;
export const ListingHeaderCommunity = styled.h4`
  margin: 0;
  padding: 0;
  ${font('body-xs-light')};
  color: ${color('gray4')};
  line-height: 1.1;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-sm-light')};
    line-height: 1.1;
  }
  order: 3;
`;

export const ContentSpanCommunity = styled.span`
  margin: 0;
  padding: 0;
  ${font('subhead-sm')};
  line-height: 1.5;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('subhead-md')};
    line-height: 1.5;
  }
  order: 2;
`;

export const NoContentSpanCommunity = styled(ContentSpanCommunity)``;

export const Text = styled.div``;

export const SchoolHeader = styled.div`
  color: #242323;
  font-size: 16px;
  font-weight: 400;
`;

export const SchoolContent = styled.div`
  color: #757575;
  font-size: 16px;
  font-weight: 300;
`;

//
//
// School Listings
//
export const ListingNonGrid = styled.li`
  display: flex;
  padding: ${space('xl')} 0;
  border-bottom: 1px solid #d4d4d4;
  align-items: center;
  gap: ${space('sm')};

  @media screen and (${query.atLeast('tablet')}) {
    gap: ${space('lg')};
  }

  @media screen and (${query.below('tablet')}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const SchoolInfo = styled.div`
  flex: 1 0 0%;
  width: 100%;
`;
export const SchoolHeaderWrapper = styled.div`
  flex: 1 0 auto;
  width: auto;
`;
export const SchoolDetails = styled.div`
  flex: 0 0 auto;
  width: auto;
  display: flex;
  gap: ${space('lg')};

  @media screen and (${query.atLeast('tablet')}) {
    gap: ${space('xl')};
  }
`;
export const DivNonGrid = styled.div`
  flex: 0 0 auto;
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const ListingHeaderSchool = styled.h4`
  margin: 0;
  padding: 0;
  ${font('subhead-sm')};
  line-height: 1.2;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('subhead-md')};
    line-height: 1.2;
  }
`;
export const ContentSpanSchool = styled(ContentSpan)`
  margin: 0;
  padding: 0;
  ${font('body-xs-light')};
  color: ${color('gray4')};
  line-height: 1.1;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-sm-light')};
    line-height: 1.1;
  }
`;
export const RatingBox = styled.div`
  ${font('headline-xxxs')};
  flex: 0 0 ${space('x6')};
  width: ${space('x6')};
  height: ${space('x6')};
  background-color: ${color('gray2')};
  border-radius: 4px;
  padding: ${space('md')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${color('fg')};

  @media screen and (${query.atLeast('tablet')}) {
    flex: 0 0 ${space('x10')};
    width: ${space('x10')};
    height: ${space('x10')};
  }
`;

export const SubContentSchool = styled.span`
  ${font('body-md-light')};
  order: 1;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-lg-light')};
  }
`;

export const SubHeaderSchool = styled(ListingHeaderCommunity)`
  order: 2;
`;
